import { Controller } from 'stimulus';

class InfiniteSlider extends Controller {
  connect() {
    let itemsCount = this.listTarget.children.length;
    const itemWidth = this.itemTarget.offsetWidth;
    let listWidth = itemsCount * itemWidth;

    // In many cases there are not enough items in the slider to fill the window
    // width twice. If there're not enough items, the slider will jump when it
    // reaches the end. We've to duplicate the items to have enough.
    const duplicatesRequired = Math.ceil((window.innerWidth * 2) / listWidth);

    for (let i = 0; i < duplicatesRequired; i += 1) {
      this.itemTargets.slice(0, itemsCount).forEach((item) => {
        this.listTarget.appendChild(item.cloneNode(true));
      });
    }

    itemsCount = this.listTarget.children.length;
    listWidth = itemsCount * itemWidth;

    this.listTarget.style.width = `${listWidth}px`;

    const durationInSeconds = Math.round(itemsCount / 1.1);

    this.itemTargets.forEach((item) => {
      item.style.animation = `infinitetranslate ${durationInSeconds}s linear infinite`;
    });

    this.createKeyframesCss(itemWidth, itemsCount);
  }

  /* eslint-disable-next-line class-methods-use-this */
  createKeyframesCss(itemWidth, itemsCount) {
    const existingStyle = document.getElementById('infinite-slider-keyframes');

    if (existingStyle) {
      existingStyle.remove();
    }

    const styleElement = document.createElement('style');
    styleElement.innerHTML = `
      @keyframes infinitetranslate {
        100% { transform:translateX(calc(-${itemWidth}px * ${itemsCount / 2}));  }
      }
    `;
    styleElement.id = 'infinite-slider-keyframes';

    document.body.appendChild(styleElement);
  }
}

InfiniteSlider.targets = [
  'list',
  'item',
];

export default InfiniteSlider;
